
export default function gtmCapture({$elCheckbox, $filterSection, $elValue}){
	(<any>window).dataLayer = (<any>window).dataLayer || [];
	// PBI-27396 AC: Uncheck need not be captured.
	if( $elCheckbox.prop('checked')) return;

	(<any>window).dataLayer.push({
		'event': 'filter',
		'filterType': 'Left Rail',
		'filterSection': $filterSection.text(),
		'filterValue': $elValue
	});
}



// WEBPACK FOOTER //
// ./src/source/Atlas.SEF.Feature.Common/Areas/AtlasCommon/Assets/Search/components/GTM-Capture.ts